// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__38MKN","col":"CardReaderDesc_col__1miYT","label":"CardReaderDesc_label__3hJmY"};